import styled from 'styled-components'

import { FormSelect } from '../../../common/components/sections'

const StyledUnknownWordsSelect = styled(FormSelect)`
  .ant-select-selector {
    margin: 0.25rem 0;
    width: 100%;
  }
`

export default StyledUnknownWordsSelect
